module.exports = __webpack_public_path__ + "static/media/account.b3737001.svg";